module.exports = __webpack_public_path__ + "static/popup_PC@1x-min-558aa0d3b10c4202181d2bda486ab8ad.webp";